import React from 'react';
import PropTypes from 'prop-types';

import ModalContainer from 'components/ModalContainer';

const PDFModal = ({ isVisible, setIsVisible, base64 }) => (
  <ModalContainer
    isOpen={isVisible}
    setIsOpen={setIsVisible}
    headText="Visualização de PDF"
    modalWidth={800}
  >
    <object
      className="w-100"
      height="500"
      data={`data:application/pdf;base64,${base64}`}
      type="application/pdf"
    >
      <p>Seu navegador não tem um plugin para visualização de PDF</p>
    </object>
  </ModalContainer>
);

export default PDFModal;

PDFModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  setIsVisible: PropTypes.func.isRequired,
  base64: PropTypes.string.isRequired,
};
